import { render, staticRenderFns } from "./add.vue?vue&type=template&id=6d9a4696&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=6d9a4696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a4696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9a4696')) {
      api.createRecord('6d9a4696', component.options)
    } else {
      api.reload('6d9a4696', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=6d9a4696&scoped=true&", function () {
      api.rerender('6d9a4696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/packing-box-order/add.vue"
export default component.exports